import { render, staticRenderFns } from "./PaymentSetupListItem.vue?vue&type=template&id=4aa49043&scoped=true&lang=pug"
import script from "./PaymentSetupListItem.vue?vue&type=script&lang=js"
export * from "./PaymentSetupListItem.vue?vue&type=script&lang=js"
import style0 from "./PaymentSetupListItem.vue?vue&type=style&index=0&id=4aa49043&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa49043",
  null
  
)

export default component.exports